import { useTranslation } from 'react-i18next'
import PremiumSlider from '../components/premium-slider'
import HomeFilter from '../components/HomeFilter'
import AnnouncesSearch from '../components/announces-search'
import ContactForm from '../components/ContactForm'

export default function SearchPage() {
  const { t } = useTranslation()

  return (
    <>
      <div id='premium-slider' className='text-center w-full align-middle'>
        <PremiumSlider />
      </div>
      <div
        id='home-filter'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <HomeFilter />
      </div>
      <div
        id='announces-home'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <AnnouncesSearch />
      </div>

      <ContactForm />
    </>
  )
}
